import React, { useState } from "react";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { useAuth } from "../core/Auth";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { TextField, Card, CardContent, Typography} from '@mui/material';
const ResetSchema = Yup.object().shape({
  newPassword1: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Password is required"),
  newPassword2: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Confirm Password is required")
});

const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $token: String!
    $newPassword1: String!
    $newPassword2: String!
  ) {
    passwordReset(
      token: $token
      newPassword1: $newPassword1
      newPassword2: $newPassword2
    ) {
      success
      errors
    }
  }
`;

export default function ResetPassword() {
  const { token } = useParams();
  const initialValues = {
    newPassword2: "",
    newPassword1: ""
  };

  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { saveAuth, setCurrentUser } = useAuth();
  const [error, setError] = useState("");
  const nav = useNavigate();

  const toggleVisibility = () => setIsVisible(!isVisible);

  const formik = useFormik({
    initialValues,
    validationSchema: ResetSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        request(BASEURL, CHANGE_PASSWORD, {
          token: token,
          newPassword1: values.newPassword1,
          newPassword2: values.newPassword2
        }).then(response => {
          if (response.passwordReset.success) {
            nav("/password-reseted");
          } else {
            setError(response.passwordReset.errors.newPassword2[0].message);
          }
        });
      } catch (error) {
        console.error(error);
        saveAuth(undefined);
        setStatus("The login details are incorrect");
        setSubmitting(false);
        setLoading(false);
      }
    }
  });

  return (
    <section className="auth-section" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Card sx={{ width: '100%', maxWidth: 400, padding: 2 }} elevation={3}>
        <CardContent>
          <Typography variant="h5" component="h3" align="center" gutterBottom sx={{ fontWeight: 'bold', color: '#3F51B5', marginBottom: 3 }}>
            Reset Password
          </Typography>
          <form onSubmit={formik.handleSubmit} noValidate id="kt_login_signin_form">
            <div className="flex flex-col gap-4">
              <div className="relative">
                <TextField
                  placeholder="Enter password"
                  type={isVisible ? "text" : "password"}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="newPassword1"
                  value={formik.values.newPassword1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.newPassword1 && Boolean(formik.errors.newPassword1)}
                  helperText={formik.touched.newPassword1 && formik.errors.newPassword1}
                />
              </div>
              <div className="relative">
                <TextField
                  placeholder="Confirm password"
                  type={isVisible ? "text" : "password"}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="newPassword2"
                  value={formik.values.newPassword2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.newPassword2 && Boolean(formik.errors.newPassword2)}
                  helperText={formik.touched.newPassword2 && formik.errors.newPassword2}
                />
              </div>
              <p className="text-danger">{error}</p>
              <div style={{display:"flex",justifyContent:"center",padding:"10px"}}>
              <button
                type="submit"
                className={`py-2 px-4 bg-[#3F51B5] hover:bg-[#3F51B5d4] text-white text-l font-bold rounded-md shadow focus:outline-none ${loading ? 'cursor-not-allowed' : ''}`}
                disabled={loading || !formik.isValid}
                style={{margin:"10px", width:"120px", backgroundColor: '#6495ED' ,color:"#F8F8FF",height:"30px",borderRadius:"10px"}}
              >
                {loading ? (
                  <span className="indicator-progress" style={{ display: "block" }}>
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                ) : (
                  'Submit'
                )}
              </button>
              </div>
              

              {formik.status && (
                <div className="text-center text-danger mb-3">{formik.status}</div>
              )}
            </div>
          </form>
        </CardContent>
      </Card>
    </section>
  );
}
